import { pillsToShowByGrade } from '../../../constant/pills-to-show-by-grade';

export const getFeaturePillsForGrade = ({
  caravanFeatures,
  grade,
  allFeatures = false,
}: {
  caravanFeatures: any;
  grade?: string;
  allFeatures?: boolean;
}) => {
  const result = pillsToShowByGrade.filter((obj) => grade === obj.grade)[0];
  const numberOfFeaturePills = result?.numberOfFeaturePills || 3;
  const numberOfHighlightPills = result?.numberOfHighlightPills || 0;

  const highlightPills = numberOfHighlightPills
    ? {
        ...(caravanFeatures.length > 0 && {
          features: allFeatures
            ? caravanFeatures
            : caravanFeatures.slice(0, numberOfHighlightPills),
        }),
        ...(result?.highlightPillStyle && { styles: result?.highlightPillStyle }),
        ...(result?.highlightPillDisplayIcon && {
          displayIcon: result?.highlightPillDisplayIcon,
        }),
      }
    : undefined;

  const featurePills = numberOfFeaturePills
    ? {
        ...(caravanFeatures.length > numberOfHighlightPills && {
          features: allFeatures
            ? caravanFeatures
            : caravanFeatures.slice(
                numberOfHighlightPills,
                numberOfFeaturePills + numberOfHighlightPills,
              ),
        }),
        ...(result?.featurePillStyle && { styles: result?.featurePillStyle }),
        ...(result?.featurePillDisplayIcon && { displayIcon: result?.featurePillDisplayIcon }),
      }
    : undefined;

  return { featurePills, highlightPills };
};
